import { Component, OnInit } from '@angular/core';
import { TranslationService } from '../../common/services/languages/translation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiHandlerService } from '../services/api-handler/api-handler.service';
import { MatDialog } from '@angular/material';
import { DialogBoxComponent } from '../../common/components/dialog-box/dialog-box.component';
import { AppState } from '../../store/state.model';
import { NgRedux, select } from '@angular-redux/store';
import { CommonDispatcher } from '../../store/common/common-dispatcher';
import { ViewASIControl } from '../common/presenter/view-asi.presenter';
import { FileDispatcher } from '../../store/file/file-dispatcher';
import { ViewPackageControl } from '../common/presenter/view-package.presenter';
import { Observable } from 'rxjs';
import { Auth } from '../../store/auth/auth-state.model';
import { Common } from '../../store/common/common-state.model';
import { UploadDialogComponent } from '../upload-dialog/upload-dialog.component';
import { SpinnerService } from '../../common/components/spinner/overlay-spinner.service';
import { environment } from '../../../environments/environment';
import { MatCard, MatCardContent } from '@angular/material/card';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { GenerationComponent } from '../generation/generation.component';
import { ShowResultComponent } from '../show-result/show-result.component';
import { ProductMappingComponent } from '../product-mapping/product-mapping.component';
import { AsiProductMapComponent } from '../asi-product-map/asi-product-map.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-dashboard-content',
    templateUrl: './dashboard-content.component.html',
    styleUrls: ['./dashboard-content.component.scss'],
    imports: [MatCard, MatCardContent, NgIf, MatButton, MatIcon, GenerationComponent, ShowResultComponent, ProductMappingComponent, AsiProductMapComponent, TranslatePipe]
})
export class DashboardContentComponent implements OnInit {
  /**
   * @arg accessType the accessTypes avaiable of the record -submitted or approved
   */
  public accessType: Array<string>;
  /**
   * @arg state the state of the record selected submitted or approved
   */
  public state: string;
  /**
   * @arg type the type of the record asi or package
   */
  public type: string;
  /**
   * @arg packageGeneration the generation value selected
   */
  public packageGeneration: string;
  /**
   * @arg asiGeneration the generation value selected
   */
  public asiGeneration: string;
  /**
   * @arg control presenter
   */
  public control: ViewASIControl | ViewPackageControl;
  /**
  *@arg authObservable to observe auth observable
  **/
  @select('auth') readonly authObservable: Observable<Auth>;
  /**
  *@arg authObservable to observe auth observable
  **/
  @select('common') readonly commonObservable: Observable<Common>;
  /**
   * @arg userRole role if submitter reviewer or approver
   */
  public userRole: Array<string>;
  /**
   * @arg showResults tab number
   */
  public showResults: boolean;
  /**
   *@arg activePortal active portal stores whether it's svpp or svppv2 or admin or dealer-admin or navi
   **/
  public activePortal: string;
  /**
   *@arg generations stores the generations supported by svpp apis
   **/
  public generations: Array<string>;
    /**
   *@arg asiUploadGeneration stores the asi upload generation result from the upload-dialog selection
   **/
   public asiUploadGeneration: string;
  constructor(
    public translate: TranslationService,
    public router: Router,
    public route: ActivatedRoute,
    public apiHandler: ApiHandlerService,
    public spinner: SpinnerService,
    public dialog: MatDialog,
    public ngRedux: NgRedux<AppState>,
    public commonDispatcher: CommonDispatcher,
    public fileDispatcher: FileDispatcher) {
    this.authObservable.subscribe((auth) => {
      this.accessType = auth.accessType;
      this.userRole = auth.userAvailableRoles;
    });
    this.commonObservable.subscribe((common) => {
      this.showResults = common.showResults === 'true' ? true : false;
    });
  }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
    this.onLoad();
  }

  /**
   * @function onLoad Method to initialize and load all the defaults
   */
  public onLoad() {
    const path = window.location.pathname;
    this.activePortal = path.indexOf('svppv2') > -1 ? 'svppv2' :
      path.indexOf('svpp') > -1 ? 'svpp' : '';
    this.defaults();
    this.commonDispatcher.setStep('view');
  }

  /**
   * @function reloadDashboard Method to reload the dashboard content
   */
  public reloadDashboard() {
    this.showResults = false;
    this.onLoad();
  }
  /**
   * @method defaults sets defaults
   */
  private defaults() {
    this.getGeneration();
    this.state = '';
    this.type = '';
    this.packageGeneration = '';
    this.asiGeneration = '';
    this.control = null;
    this.commonDispatcher.showResults('');
    this.showResults = false;
  }
  /**
   * @method setType sets the type  (asi or package) of records to be fetched and resets generation selector
   * @arg type  selected asi or package
   */
  public setType(type): void {
    this.defaults();
    this.type = type === 'package' ? 'package' : 'asi';
    this.fileDispatcher.setAsiGeneration('');
    this.fileDispatcher.setPackageGeneration('');
    this.commonDispatcher.setStep('view');
  }
  /**
   * @method setState sets the state ( submitted or approved) of records to be fetched
   * @arg state  state (submitted or approved)
   */
  public setState(state: string, type: string): void {
    this.setType(type);
    this.fileDispatcher.setReviewApproved(state);
    this.state = state;
    this.control = type === 'package' ? new ViewPackageControl(this.activePortal) : new ViewASIControl(this.activePortal);
    this.fileDispatcher.setFiletype(type);
    this.getProductsASI();
  }
  /**
   * @method getProductsASI api call to get the asi capabilities or packages
   */
  private getProductsASI(): void {
    const spinnerRef = this.spinner.open();
    this.apiHandler.getRequest(this.control.getApiEndpoint, this.control.getParams(this.state)).subscribe({
      next: (response) => {
        this.successProductsASI(response);
        spinnerRef.close();
      },
      error: (error) => {
        this.showError(error);
        spinnerRef.close();
      }
    }
    );
  }
  /**
   * @method showError displays the error message
   * @arg error error response from the api
   */
  private showError(error: object): void {
    if (error['errorCode'] === 'UNAUTHORIZED') {
      this.routeError();
    } else {
      this.commonDispatcher.setErrorCode(error['errorCode']);
      this.dialog.open(DialogBoxComponent, {
        data: {
          type: 'api-error',
          message: error['errorMessage'],
          endPoint: error['api']
        },
        width: '30em',
        height: 'auto'
      });
    }
  }
  /**
   * @arg routeError routes to error page
   * @returns void
   **/
  private routeError(): void {
    this.router.navigate(['dashboard/error'], { queryParams: {}, skipLocationChange: true });
  }
  /**
   * @method successProductsASI success callback of the api call
   * @arg response response from the api call
   */
  private successProductsASI(response): void {
    this.commonDispatcher.setGetresposne(response.payload[this.type === 'asi' ?
      (this.activePortal === 'svppv2' ? 'asiCapabilitiesMappingV2' : (this.state === 'submitted' ? 'asiCapabilitiesForReview' : 'asiCapabilities')) :
      'products']);
    this.commonDispatcher.showResults('true');
  }
  /**
   * @method setGeneration sets generation on select
   */
  public setGeneration(generation: string, type: string): void {
    type === 'asi' ? this.asiGeneration = generation : this.packageGeneration = generation;
    type === 'asi' ? this.packageGeneration = '' : this.asiGeneration = '';
  }
  /**
   * opens the upload file dialog box
   */
  public openDialog(filetype: string) {
    this.commonDispatcher.showResults('');
    const uploadDialog = this.dialog.open(UploadDialogComponent, {
      width: '35em',
      height: 'auto',
      data: { type: filetype }
    });

    uploadDialog.afterClosed().subscribe(result => {
      this.asiUploadGeneration = result['asiUploadGenerationSelection'];
    })
  }
  /**
   * @method getGeneration to fetch the valid generation values
   */
  public getGeneration(): void {
    const spinnerRef = this.spinner.open();
    this.apiHandler.getRequest(`${environment.ProductCatalog.apis.generation}`, { type: 'getGeneration' }).subscribe({
      next: (response) => {
        this.generations = response.payload.generations;
        this.fileDispatcher.setSupportedGeneration(response.payload.generations);
        spinnerRef.close();
      },
      error: (error) => spinnerRef.close()
    }
    );
  }
}
